export default __webpack_public_path__ + "static/media/favour.9b0f4be4.png";